export const ChartOptions = {
  general:{
    responsive: true,
    maintainAspectRatio:false,
    scales: {
      xAxes: [{
        ticks: {
          beginAtZero: false,
          reverse:true
        }
      }]
    },
    legend: {
      display: false,
      position:'bottom'
    },
    layout:{
      padding:{
        top:100,
        bottom:100,
        left: 10,
        right: 10,
      }
    },

  },
  live:{
    responsive: true,
    maintainAspectRatio:false,
    scales: {
      xAxes: [{
        ticks: {
          beginAtZero: false,
          reverse:true
        }
      }]
    },
    legend: {
      display: false,
      position:'bottom'
    },
    layout:{
      padding:{
        top:0,
        bottom:0
      }
    }
  },
  hour:{
    responsive: true,
    maintainAspectRatio:false,
    scales: {
      xAxes: [{
        ticks: {
          beginAtZero: false,
          reverse:true
        }
      }]
    },
    layout:{
      padding:{
        top:0,
        bottom:0
      }
    }
  },
  memPie:{
    responsive: true,
    layout:{
      padding:{
        top:0,
        bottom:0
      }
    }
  },
  trafficPie:{
    maintainAspectRatio:false,
    responsive: true,
    legend: {
      display: false,
      position:'bottom'
    },
    layout:{
      padding:{
        top:0,
        bottom:0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chart_options.js